@if (padding) {
    <div class="agpr-block-padding" role="group"  [attr.aria-labelledby]="id + '_label'">
        <div class="agpr-block-padding-header" [ngClass]="headerClass">
            @if (showLabel) {
                <span
                    [id]="id + '_label'"
                    [class.agpr-block-padding-header-label--heading]="headerLabelHeading"
                >{{ 'PageBuilder.formField.padding' | localize }}</span>
            }
            <agpr-checkbox
                [id]="id + '_moreOptions'"
                [label]="'PageBuilder.formField.padding.moreOption' | localize"
                [binary]="true"
                [(ngModel)]="padding.paddingOption"
                (ngModelChange)="optionChange($event)"
            ></agpr-checkbox>
        </div>
        <div *ngIf="!padding.paddingOption" class="agpr-block-padding-all">
            <agpr-number-input
                [id]="id + '_all'"
                [min]="0"
                [max]="100"
                [(ngModel)]="padding.paddingAll"
                (ngModelChange)="onValueChange()"
                unit="px"
                [integerOnly]="true"
            ></agpr-number-input>
        </div>
        <div *ngIf="padding.paddingOption">
            <div class="agpr-block-padding-row">
                <agpr-number-input
                    [id]="id + '_top'"
                    [label]="'PageBuilder.formField.padding.top' | localize"
                    [(ngModel)]="padding.topPadding"
                    (ngModelChange)="onValueChange()"
                    [min]="0"
                    [max]="100"
                    unit="px"
                    [integerOnly]="true"
                ></agpr-number-input>
                <agpr-number-input
                    [id]="id + '_left'"
                    *ngIf="!verticalOnly"
                    [label]="'PageBuilder.formField.padding.left' | localize"
                    [(ngModel)]="padding.leftPadding"
                    (ngModelChange)="onValueChange()"
                    [min]="0"
                    [max]="100"
                    unit="px"
                    [integerOnly]="true"
                ></agpr-number-input>
                <agpr-number-input
                    [id]="id + '_bottom'"
                    *ngIf="verticalOnly"
                    [label]="'PageBuilder.formField.padding.bottom' | localize"
                    [(ngModel)]="padding.bottomPadding"
                    (ngModelChange)="onValueChange()"
                    [min]="0"
                    [max]="100"
                    unit="px"
                    [integerOnly]="true"
            ></agpr-number-input>
            </div>
            <div
                *ngIf="!verticalOnly"
                class="agpr-block-padding-row">
                <agpr-number-input
                    [id]="id + '_bottom'"
                    [label]="'PageBuilder.formField.padding.bottom' | localize"
                    [(ngModel)]="padding.bottomPadding"
                    (ngModelChange)="onValueChange()"
                    [min]="0"
                    [max]="100"
                    unit="px"
                    [integerOnly]="true"
                ></agpr-number-input>
                <agpr-number-input
                    [id]="id + '_right'"
                    [label]="'PageBuilder.formField.padding.right' | localize"
                    [(ngModel)]="padding.rightPadding"
                    (ngModelChange)="onValueChange()"
                    [min]="0"
                    [max]="100"
                    unit="px"
                    [integerOnly]="true"
                ></agpr-number-input>
            </div>
        </div>
    </div>
}
